import React from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import { ISelectInputFieldControlModeTemplate } from '@src/types/ControlModes';
import { inputStyles } from '../styles';
import { FormValue } from '../../context/formReducer';

interface SelectFieldProps {
  field: ISelectInputFieldControlModeTemplate;
  fieldValue: FormValue | undefined;
  hasError: boolean;
  errorMessage: string;
  handleSelectChange: (event: SelectChangeEvent<string>) => void;
}

const SelectField: React.FC<SelectFieldProps> = ({
  field,
  fieldValue,
  hasError,
  errorMessage,
  handleSelectChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <FormControl
        fullWidth
        variant='outlined'
        size='small'
        error={hasError}
        sx={{
          ...inputStyles,
          minWidth: '200px',
          maxWidth: '100%',
          width: 'auto',
        }}
      >
        <Select
          name={field.controllerField}
          value={
            fieldValue !== undefined && fieldValue !== null
              ? String(fieldValue)
              : field.defaultValue !== undefined
                ? String(field.defaultValue)
                : ''
          }
          onChange={handleSelectChange}
          displayEmpty
          error={hasError}
          inputProps={{ style: { textAlign: 'center' } }}
        >
          {field.listOptions.map((option, optionIndex) => (
            <MenuItem
              key={`option-${field.controllerField}-${optionIndex}-${option}`}
              value={option}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
        {hasError && (
          <Typography variant='caption' color='error'>
            {errorMessage}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};

export default SelectField;
